import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import React, { useState, useEffect, useRef } from 'react';
import api from '../service/AxiosInstance';
import Axios from 'axios';
import moment from 'moment';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import 'primeflex/primeflex.css';
import { Divider } from 'primereact/divider';
import SelectSpecialite from '../components/SelectSpecialite';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { printPDF } from '../service/PrintService';
import './DataTable.css';
import ReactExport from 'react-export-excel';
import { Circles } from 'react-loader-spinner'


const MesDocs = () => {

    const [listDoc, setListDoc] = useState([]);
    const [listDocAll, setListDocAll] = useState([]);
    const [doc, setDoc] = useState({});
    const [exercices, setExcercices] = useState([]);
    const [exercice, setExercice] = useState(2023);
    const [nbDoc, setNbDoc] = useState(0);
    const [etatBon, setEtatBon] = useState('All');
    const [docDialog, setDocDialog] = useState(false);
    const [specialite, setSpecialite] = useState('xxx');
    const [listFourn, setListFourn] = useState([]);
    const [fourn, setFourn] = useState(null);
    const [presc, setPresc] = useState('99999');
    const [listPrescripteurs, setListPrescripteurs] = useState([]);
    const [listBenef, setListBenef] = useState([]);
    const [benef, setBenef] = useState(null);
    const [typeBenef, setTypeBenef] = useState('0');
    const [optionFourn, setOptionFourn] = useState([]);
    const [optionBenef, setOptionBenef] = useState([]);
    const [typeDoc, setTypeDoc] = useState('LGI');
    const [listPrestations, setListPrestations] = useState([]);
    const [prestation, setPrestation] = useState('00');
    const dt = useRef(null);
    const [formData, setFormData] = useState({});
    const [showMessage, setShowMessage] = useState(false);
    const [enteteDialog, setEnteteDialog] = useState(null);
    const [x, setX] = useState(0);
    const toast = useRef(null);
    const [deleteDocDialog, setDeleteDocDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [activeButton, setActiveButton] = useState(true);


    const user_connect_local = localStorage.getItem("user_connect");
    const user_connect = JSON.parse(user_connect_local);

    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


    const etatsBon = [
        { label: 'Tous', value: 'All' },
        { label: 'Traités', value: 'OK' },
        { label: 'Non Traités', value: 'KO' }

    ];

    const typeDocs = [
        { label: 'Bon de Commande Pharmacie', value: 'BPI' },
        { label: 'Lettre de Garantie', value: 'LGI' }
        // { label: 'Lettre Hospitalisation', value: 'LHI' },
        // { label: 'Bon de Commande Optique', value: 'BCI' },
    ]

    const typeBenefs = [
        { label: 'Choisir', value: '0' },
        { label: 'Participant', value: '1' },
        { label: 'Epouse', value: '2' },
        { label: 'Enfant', value: '3' },
        { label: 'Epoux', value: '4' },
        { label: 'Ascendant', value: '5' },
        { label: 'Autres', value: '6' }
    ];

    const defaultValues = {
        matribenef: '',
        matripart: '',
        codesoc: '',
        user_id: '',
        codeprest: '',
        natprest: '',
        typedoc: '',
        datedoc: moment.utc(new Date()),
        datepresc: new Date(),
        codefourn: null,
        codepresc: '99999',
        typebenef: ''
    }

    const tabFournBySpec = [];
    const tabBenefByPart = [];
    const tabPrestations = [];
    const tabPrescripteurs = [];

    const populate = (items) => {

        tabFournBySpec.push({ label: '99999 - FOURNISSEUR DE SOINS DIVERS', value: '99999' });

        items.map((item) => {
            tabFournBySpec.push({
                label: item.numFourn + ' - ' + item.raisoc,
                value: item.numFourn
            })
        })
    };

    const populateBenef = (items) => {

        items.map((item) => {
            tabBenefByPart.push({
                label: item.matribenef + ' - ' + `${item.prenoms}`,
                value: item.matribenef
            })
        })
    };

    const populatePrestations = (items) => {

        items.map((item) => {
            if (item.codeprest !== '04') {
                tabPrestations.push({
                    label: item.codeprest + ' - ' + item.intitule,
                    value: item.codeprest
                })
            }

        })
    };

    const populatePrescripteurs = (items) => {

        tabPrescripteurs.push({ label: 'FOURNISSEUR DE SOINS DIVERS', value: '99999' });

        items.map((item) => {
            tabPrescripteurs.push({
                label: item.raisoc + ' - ' + item.intitule,
                value: item.numFourn
            })
        })
    };

    useEffect(() => {
        api.get("Prestations/list",
            { headers: { user_id: `${user_connect.numcont}` } })
            .then(resp => {
                populatePrestations(resp.data);
                setListPrestations(tabPrestations);
            });
    }, []);

    useEffect(() => {
        api.get("Benef/list/" + user_connect.numcont)
            .then(resp => {
                setListBenef(resp.data);
                populateBenef(resp.data);
                setOptionBenef(tabBenefByPart);
            });
    }, []);

    useEffect(() => {
        api.get("Fournisseur/list")
            .then(resp => {
                setListFourn(resp.data);
                populatePrescripteurs(resp.data);
                setListPrescripteurs(tabPrescripteurs);
            });
    }, []);

    useEffect(() => {
        api.get("Document/Exercices2/" + user_connect.numcont)
            .then(resp => {
                setExcercices(resp.data);
            });
    }, []);


    useEffect(() => {

        setLoading(true);

        api.get("Document/ByPartExt", {
            params: {
                matricule: user_connect.numcont,
                annee: exercice
            }
        })
            .then(resp => {
                setListDoc(resp.data);
                setListDocAll(resp.data);
                // setDoc(resp.data[0]);
                setNbDoc(resp.data.length);

                setLoading(false);
            });

    }, [exercice, x]);


    const accept = () => {
        deleteDoc(doc.numdoc);
        let _listDesDoc = [...listDoc].filter(val => val.numdoc !== doc.numdoc);
        setListDoc(_listDesDoc);
        setNbDoc(_listDesDoc.length);


        toast.current.show({ severity: 'info', summary: 'Confirmée', detail: 'Suppression Effectuée !', life: 3000 });
    }

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Rejectée', detail: 'Suppression Annulée !', life: 3000 });
    }


    const hideDialog = () => {
        setDocDialog(false);
    };

    const onChangeTypeBenef = (e) => {
        setTypeBenef(e.value);

        if (e.value == 0) {
            setBenef(null);
        } else {
            const tabFilter = [...listBenef].filter(f => f.codebenef === e.value);

            if (tabFilter.length == 0) {
                setBenef(null);
            } else {
                populateBenef(tabFilter.filter(f => f.suspension_benef != 'S'));
                setOptionBenef(tabBenefByPart);
                setBenef(tabBenefByPart[0].value);
            }
        }
    };

    const onChangeTypeDoc = (e) => {
        setTypeDoc(e.value);
        if (e.value === 'BPI') {
            setSpecialite('06');
            let val = { value: '06' }
            onChangeSpecialite(val);
        } else if (e.value === 'BCI') {
            setSpecialite('04');
            let val = { value: '04' }
            onChangeSpecialite(val);
        } else {
            setSpecialite('xxx');
            let val = { value: 'xxx' }
            onChangeSpecialite(val);
        }
    }

    const onChangeSpecialite = (e) => {
        setSpecialite(e.value);
        setPrestation(e.value);

        if (e.value === 'xxx') {
            setFourn(null);
            // setPrestation('00');
        } else {
            const tabFilter = [...listFourn].filter(f => f.codespe === e.value);
            if (tabFilter.length == 0) {
                setFourn(null);
                // setPrestation('00');
            } else {
                populate(tabFilter);
                setOptionFourn(tabFournBySpec);
                // setFourn(tabFournBySpec[0].value);
                setFourn('99999');

            }

        }

    }

    const onEditDoc = (data) => {

        setEnteteDialog('Modification Document : ' + data.numdoc);

        setDoc(data);

        setTypeDoc(data.typedoc);
        setTypeBenef(data.typebenef);

        let val = { value: data.typebenef };

        onChangeTypeBenef(val);

        setBenef(data.matribenef);



        setSpecialite(data.codeprest);
        let val2 = { value: data.codeprest }

        onChangeSpecialite(val2);

        setFourn(data.codefourn);
        setPresc(data.codepresc);
        setPrestation(data.natprest);

        // console.log(data);
        setDocDialog(true);
    };

    const resetForm = () => {

        setTypeBenef('0');
        setSpecialite('xxx');
        setTypeDoc('LGI');
        setPrestation('00');
        setBenef(null);
        setFourn(null);
        setPresc('99999');
        setDoc({ ...defaultValues });
    };



    const onChangEtatBon = (e) => {

        let tabList = [];

        setEtatBon(e.value);


        if (e.value === 'All') {
            tabList = [...listDocAll];
            setListDoc(tabList)
            setNbDoc(tabList.length)
        } else {
            tabList = [...listDocAll];
            const tabFilter = tabList.filter(f => f.etat === e.value);
            setListDoc(tabFilter);
            setNbDoc(tabFilter.length)
        }
    }

    const dateDocTemplate = (rowData) => {
        return moment.utc(rowData.datedoc).format("DD-MM-YYYY");
    }


    const openNewDoc = () => {
        setEnteteDialog("Création Nouveau Document");
        resetForm();
        setDocDialog(true);
    }

    const confirmDeleteDoc = (doc) => {
        setDoc(doc);
        setDeleteDocDialog(true);
    }

    const createOrUpdateDoc = (doc) => {

        if (doc.numdoc == null) {
            addDoc();
        } else {
            updateDoc(doc);
        };
    }

    const updateDoc = (doc) => {

        doc.typebenef = typeBenef;
        doc.matribenef = benef;
        doc.codefourn = fourn;
        doc.codeprest = specialite;
        doc.codepresc = presc;

        api.put("Document/IPM/updateBefore", doc)
            .then(resp => {
                const obbjResponse = resp.data;

                if (obbjResponse) {
                    setX(Math.random());
                    setDocDialog(false);
                    toast.current.show({ severity: 'success', summary: 'Modification', detail: 'Document modifié avec succès !' });
                }
            });

        setX(Math.random());

    }

    const addDoc = (doc) => {


        doc = { ...defaultValues };

        doc.typedoc = typeDoc;
        doc.typebenef = typeBenef;
        doc.codefourn = fourn;
        doc.codeprest = specialite;
        doc.natprest = prestation;
        doc.matribenef = benef;
        doc.codepresc = presc;
        doc.matripart = user_connect.numcont;
        doc.user_id = user_connect.numcont;
        doc.codesoc = user_connect.codesoc;

        setActiveButton(false);

        api.post("Document/IPM/add", doc)


            .then(resp => {

                const obbjResponse = resp.data;

                // if (specialite === '06' && typeDoc != 'BPI') {
                //     toast.current.show({ severity: 'error', summary: 'Création Document', detail: 'Type de document non Conforme pour la pharmacie !' });
                // } else
                if (obbjResponse.Added) {
                    setX(Math.random());
                    setDocDialog(false);
                    toast.current.show({ severity: 'success', summary: 'Création Document', detail: 'Document Crée avec succès !' });
                }

                setActiveButton(true);

            });

    }

    const deleteDoc = (numdoc) => {
        api.delete("Document/delete/" + numdoc + "/IPM/" + user_connect.numcont, {
            headers: { username: `${user_connect.numcont}` },
        })
            .then(resp => {
                console.log(resp.data);
            });
    };

    const headerEditDoc = (
        <React.Fragment>

            <span>{enteteDialog}</span>

        </React.Fragment>
    );

    const footerEditDoc = (
        <React.Fragment>
            <Divider />
            <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Enregistrer" icon="pi pi-check" className="p-button-text" onClick={() => createOrUpdateDoc(doc)} disabled={!fourn || !benef || activeButton == false} />
        </React.Fragment>
    );

    const actions = (rowData) => {
        return (
            <React.Fragment>
                {(rowData.etat == 'KO' && (rowData.matripart === rowData.user_id)) && <Button icon="pi pi-pencil" className="p-button-rounded p-button-outlined p-button-success mr-1 actions" tooltip="Editer" style={{ 'fontSize': '1.2em' }} onClick={() => onEditDoc(rowData)} />}
                {(rowData.etat == 'KO' && (rowData.matripart === rowData.user_id)) && <Button icon="pi pi-print" className="p-button-rounded p-button-outlined p-button-info mr-1 actions " tooltip='Imprimer' style={{ 'fontSize': '1.2em' }} onClick={() => printPDF('Print/Document2/' + rowData.numdoc + '/' + user_connect.numcont)} />}
                {(rowData.etat == 'KO' && (rowData.matripart === rowData.user_id)) && <Button icon="pi pi-trash" className="p-button-rounded p-button-outlined p-button-danger actions" tooltip='Supp.' style={{ 'fontSize': '1.2em' }} onClick={() => confirmDeleteDoc(rowData)} />}
            </React.Fragment>
        );
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                {loading &&
                    <Circles
                        height="50"
                        width="50"
                        color="#4fa94d"
                        ariaLabel="circles-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                    />
                }
                <Button label="Créer" icon="pi pi-plus" className="p-button-raised p-button-text p-button-info ml-3 mr-2" onClick={() => openNewDoc()} disabled={user_connect.suspension_adht || user_connect.suspension_part != 'A'} />
                <ExcelFile filename='Liste_des_Documents' element={<Button label="Export" icon="pi pi-upload" className="p-button-raised p-button-help p-button-text mr-2" />}>
                    <ExcelSheet data={listDoc} name="ListeDoc">
                        <ExcelColumn label="Num Doc" value="numdoc" />
                        <ExcelColumn label="Type Doc" value={(col) => col.typedoc === "BPI" ? "Bon de Pharmacie" : col.typedoc === "LGI" ? "Lettre de Garantie" : col.typedoc === "BCI" ? "Bon Optique" : "Lettre Hospitalisation"} />
                        <ExcelColumn label="Date Doc" value="datedoc" />
                        <ExcelColumn label="Type Benef" value={(col) => col.typebenef == 3 ? "Enfant" : col.typebenef == 2 ? "Epouse" : "Moi-Même"} />
                        <ExcelColumn label="Bénéficiare" value="beneficiaire" />
                        <ExcelColumn label="Prestataire" value="fournisseur" />
                        <ExcelColumn label="Etat" value={(col) => col.etat === "OK" ? "Traité" : "Non Traité"} />

                    </ExcelSheet>

                </ExcelFile>
            </React.Fragment>
        )
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Dropdown className='ml-2' value={exercice} options={exercices} onChange={(e) => setExercice(e.value)} placeholder="Année" />
                <Dropdown className='ml-2' value={etatBon} options={etatsBon} onChange={onChangEtatBon} placeholder="Etat" />
            </React.Fragment>
        )
    }


    return (
        <div className="datatable-crud-demo">
            <Toast ref={toast} />

            <ConfirmDialog visible={deleteDocDialog} onHide={() => setDeleteDocDialog(false)} message="Etes vous sûr de vouloir supprimer?"
                header="Confirmation" icon="pi pi-exclamation-triangle" accept={accept} reject={reject}
                acceptLabel="Oui" rejectLabel="Non"
                acceptClassName='p-button-danger' />

            <div className="grid">

                <div className="col-12">
                    <div className="card">
                        <h3>Mes Documents</h3>
                        {/* <h5>{`Mes Documents - ${user_connect.prenom} ${user_connect.nom}`}</h5> */}
                        <Divider />
                        <div>
                            <Toolbar className="mb-2 mt-2" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                            <DataTable value={listDoc} ref={dt} size='small'
                                rowHover responsiveLayout='scroll'
                                dataKey='numdoc'
                                paginator resizableColumns
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                rows={8} rowsPerPageOptions={[8, 12, 16]}>
                                <Column field='numdoc' header='Numéro' sortable footer={'Total : ' + nbDoc} ></Column>
                                <Column field='typedoc' header='Type' sortable
                                    body={(data) => data.typedoc === 'BPI' ? 'Bon Pharmacie' :
                                        (data.typedoc === 'LGI' ? 'Lettre de Garantie' : (data.typedoc === 'LHI' ? 'Lettre Hospitalisation' :
                                            (data.typedoc === 'BCI' ? 'Bon Optique' : '')))}></Column>
                                <Column field='datedoc' header='Date' sortable body={dateDocTemplate}></Column>
                                <Column field='typebenef' header='Type Bénéf.' body={(data) => data.typebenef === '2' ? "Epoux(e)" : data.typebenef === '3' ? "Enfant" : data.typebenef === '1' ? "Participant" : "Autre"} sortable ></Column>
                                <Column field='beneficiaire' header='BénéFiciaire' sortable ></Column>
                                <Column field='fournisseur' header='Prestataire' sortable ></Column>
                                <Column field='etat' className='actions' header='Etat' align='center' body={(data) => data.etat == 'OK' ? <i className="pi pi-check-circle" style={{ 'fontSize': '1.2em', 'color': 'green' }}></i> : <i className="pi pi-ban" style={{ 'fontSize': '1.2em', 'color': 'red' }}></i>}  ></Column>
                                <Column header='Actions' body={actions} exportable={false} style={{ minWidth: '8rem' }} ></Column>

                            </DataTable>
                        </div>
                    </div>
                </div>

                <Dialog visible={docDialog} header={headerEditDoc}
                    breakpoints={{ '960px': '75vw' }} style={{ width: '60vw' }}
                    position='top' modal className="p-fluid"
                    footer={footerEditDoc}
                    onHide={() => setDocDialog(false)}>

                    <h3>Type de Document</h3>
                    <div className='p-fluid grid formgrid'>

                        <div className="field col-12 md:col-6">
                            <Dropdown id="typeDoc" value={typeDoc} options={typeDocs} onChange={onChangeTypeDoc} optionLabel='label' optionValue='value' disabled={doc.numdoc != null} />
                        </div>

                    </div>

                    <div className='p-fluid grid formgrid'>

                        <div className="field col-12 md:col-6">
                            <Fieldset legend="Bénéficiaire">
                                <div>
                                    <label htmlFor="typeBenef">Type de Bénéf.</label>
                                    <Dropdown id="typeBenef" value={typeBenef} options={typeBenefs} onChange={onChangeTypeBenef} optionLabel='label' optionValue='value' />
                                </div>
                                <div className='mt-3'>
                                    <label htmlFor="matribenef">Bénéficiaire</label>
                                    <Dropdown id="matribenef" value={benef} options={optionBenef} onChange={(e) => setBenef(e.value)} optionLabel='label' optionValue='value' disabled={benef == null} />
                                </div>
                            </Fieldset>

                        </div>
                        <div className="field col-12 md:col-6">
                            <Fieldset legend="Prestataire">
                                <div>
                                    <label htmlFor="spec">Spécialité</label>
                                    <SelectSpecialite id='specialite' onChange={onChangeSpecialite} value={specialite} disabled={specialite === '06' || specialite === '04'} ></SelectSpecialite>
                                </div>
                                <div className='mt-3'>
                                    <label htmlFor="fourn">Fournisseur</label>
                                    <Dropdown id="fourn" filter value={fourn} options={optionFourn} onChange={(e) => setFourn(e.value)} optionLabel='label' optionValue='value' disabled={fourn == null} />
                                </div>
                            </Fieldset>
                        </div>

                    </div>

                    <div className='p-fluid grid formgrid'>

                        <div className="field col-12 md:col-6">
                            <h3>Prescripteur</h3>
                            <div>
                                <Dropdown id="presc" filter value={presc} options={listPrescripteurs} onChange={(e) => setPresc(e.value)} optionLabel='label' optionValue='value' />
                            </div>

                        </div>

                        <div className="field col-12 md:col-6">
                            <h3>Nature Prestation</h3>
                            <div>
                                <Dropdown id="natprest" value={prestation} options={listPrestations} onChange={(e) => setPrestation(e.value)} optionLabel='label' optionValue='value' disabled={specialite === '06' || specialite === '04'} />
                            </div>

                        </div>


                    </div>



                </Dialog>
            </div>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(MesDocs, comparisonFn);
